(($, Drupal, cookies, once) => {

  Drupal.Collapsiblock = Drupal.Collapsiblock || {}

  Drupal.behaviors.collapsiblock = {
    attach: (context, settings) => {

      let cookieString = cookies.get('collapsiblock')
      let cookieData = cookieString ? JSON.parse(cookieString) : {}
      const slideType = settings.collapsiblock.slide_type
      const activePages = settings.collapsiblock.active_pages
      const slideSpeed = parseInt(settings.collapsiblock.slide_speed, 10)

      $(once('collapsiblock', '.collapsiblock')).each((i, titleElt) => {
        const id = titleElt.id.split('-').pop()
        if (titleElt.children.length > 0) {

          let titleJQ = $(titleElt)

          // Only add the button if one or more of the children are visible.
          if (titleJQ.children('.visually-hidden').length < titleElt.children.length) {
            // Status values: 1 = not collapsible, 2 = collapsible and expanded,
            // 3 = collapsible and collapsed, 4 = always collapsed,
            // 5 = always expanded
            const status = titleJQ.data('collapsiblock-action')
            if (status === 1) {
              return
            }

            titleElt.target = titleJQ.siblings().not($('.contextual'))
            let targetJQ = $(titleElt.target)
            $(titleElt)
              .wrapInner('<button id="#collapse-' + id + '" role="link" />')
              .click(() => {
                if (titleJQ.is('.collapsiblockCollapsed')) {
                  titleJQ.removeClass('collapsiblockCollapsed')
                  if (slideType === 1) {
                    targetJQ.slideDown(slideSpeed).attr('aria-hidden', false)
                  } else {
                    targetJQ.animate({
                      height: 'show',
                      opacity: 'show'
                    }, slideSpeed)
                  }

                  // Don't save cookie data if the block is always collapsed.
                  if (status !== 4 && status !== 5) {
                    cookieData[id] = 1
                  }
                } else {
                  titleJQ.addClass('collapsiblockCollapsed')
                  if (slideType === 1) {
                    targetJQ.slideUp(slideSpeed).attr('aria-hidden', true)
                  } else {
                    targetJQ.animate({
                      height: 'hide',
                      opacity: 'hide'
                    }, slideSpeed)
                  }

                  // Don't save cookie data if the block is always collapsed.
                  if (status !== 4 && status !== 5) {
                    cookieData[id] = 0
                  }
                }
                // Stringify the object in JSON format for saving in the cookie.
                cookies.set('collapsiblock', JSON.stringify(cookieData), {
                  path: drupalSettings.path.baseUrl
                })
              })
            // Leave active blocks if Remember collapsed on active pages is false.
            // If the block is expanded, do nothing.
            if (status === 4 || (cookieData[id] === 0 || (status === 3 && cookieData[id] === undefined))) {
              if (!titleJQ.find('a.active').length || activePages === 1) {
                // Allow block content to assign class 'collapsiblock-force-open'
                // to it's content to force itself to stay open. E.g. useful if
                // block contains a form that was just ajaxly updated and should
                // be visible
                if (titleElt.target.hasClass('collapsiblock-force-open') || titleElt.target.find('.collapsiblock-force-open').length > 0) {
                  return
                }
                $(titleElt).addClass('collapsiblockCollapsed')
                $(titleElt.target).hide()
              }
            }
          }
        }

      })
    }
  }

})(jQuery, Drupal, window.Cookies, once)
